import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { selectCaseSatisfactions } from '@debbie/cortex/dist/case/selectors.js';
import { Modal } from '..//index.js';
import CaseSatisfaction from '../CaseSatisfaction.js';
import Frown from '../Icons/Frown.js';
import Meh from '../Icons/Meh.js';
import Smile from '../Icons/Smile.js';
const SatisfactionIcon = (props) => {
    switch (props.satisfaction) {
        case 1:
            return React.createElement(Frown, null);
        case 3:
            return React.createElement(Meh, null);
        case 5:
            return React.createElement(Smile, null);
        default:
            return null;
    }
};
const CaseSatisfactions = (props) => {
    const caseSatisfactions = useSelector((s) => selectCaseSatisfactions(s, props.caseId)) ||
        [];
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: () => setIsModalOpen(true), style: { cursor: 'pointer', marginTop: '10px' } }, caseSatisfactions &&
            caseSatisfactions.map((s) => (React.createElement(Satisfaction, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `Debtor satisfaction${s.comment ? `: ${s.comment}` : ''}`, key: s.satisfactionId },
                ' ',
                React.createElement(SatisfactionIcon, { satisfaction: s.satisfaction }),
                ' ')))),
        isModalOpen && (React.createElement(Modal, { header: "Satisfaction", onToggle: () => setIsModalOpen(!isModalOpen), maxWidth: "400px" }, caseSatisfactions &&
            caseSatisfactions.map((s) => React.createElement(CaseSatisfaction, { satisfaction: s }))))));
};
export default CaseSatisfactions;
const Satisfaction = styled.div `
  margin-right: 5px;
  background-color: lightgrey;
  display: inline-block;
  padding: 5px 5px 2px 5px;
  border-radius: 3px;
`;
//# sourceMappingURL=CaseSatisfactions.js.map